import type { LogUserActive } from '@/models/interface/logUserActive';
import { ApiFactory, type ApiResponse } from '@/utils/api';

export class userActiveLogService extends ApiFactory {
  constructor() {
    super('UserActiveLog');
  }

  logUserActive(params: LogUserActive): Promise<ApiResponse> {
    return super.post('LogUserActive', params);
  }
}
